import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HistoryStore } from '@iotv/datamodel-core';
import { Grid, Stack } from '@mui/material';
import React, { useContext } from 'react';
import { AppMainViewContext } from '../../../../ContextProviders/AppContextProvider';
import { useKeySelector } from '../../../../hooks/useKeySelector';
import { HistoryLineChart } from '../../../../v2/components/charts/HistoryLineChart';
import { getFlatLCDDeviceMessage } from '../../../NetworkSystem/NetworkMonitoriingTableView/fns/getFlatLCDDeviceMessage';
import { useSingleDeviceNWDataTableView } from '../../../NetworkSystem/NetworkMonitoriingTableView/hooks/useSingleDeviceNWDataTableView';
import MessageData from './MessageData';
const debug = process.env.REACT_APP_DEBUG && false;
const graphableKeys = ['battery', 'esp', 'fCntInc', 'humidity', 'rssi', 'sf', 'snr', 'temperature'];
const graphableNames = {
    battery: 'Battery',
    esp: 'ESP',
    fCntInc: 'Frame Increment',
    humidity: 'Humidity',
    rssi: 'RSSI',
    sf: 'Spreading Factor',
    snr: 'SNR',
    temperature: 'Temperature',
};
const lcdMessagesToHistoryStore = (messages) => {
    const snapshots = [];
    for (const message of messages) {
        const flatLCDMessage = getFlatLCDDeviceMessage(message);
        const { timestamp, battery = null, esp = null, fCntInc = null, humidity = null, rssi = null, sf = null, snr = null, temperature = null } = flatLCDMessage;
        if (!timestamp)
            continue;
        const snapshot = {
            timestamp,
            state: { battery, esp, fCntInc, humidity, rssi, sf, snr, temperature },
        };
        snapshots.unshift(snapshot);
    }
    return HistoryStore.fromStateSnapshotArray(snapshots);
};
const NetworkAndMessagesTab = ({ device, lns, mostProximateCustomer, transactionFunctions, userFunctions, }) => {
    debug && console.log(`NetworkAndMessagesTab rendering with`, { device, lns });
    const [{ isSmallView }] = useContext(AppMainViewContext);
    const { Table, deviceMessages } = useSingleDeviceNWDataTableView({
        device,
    });
    const historyObject = lcdMessagesToHistoryStore(deviceMessages);
    const { requiredKeys, component: KeySelector } = useKeySelector({
        initialKeys: graphableKeys,
        initialRequiredKeys: graphableKeys,
        readableKeyNames: graphableNames,
    });
    return (_jsxs(Grid, { container: true, children: [_jsx(Grid, { size: { xs: 12, lg: 6 }, children: _jsx(MessageData, { device, lns, mostProximateCustomer, transactionFunctions, userFunctions }) }), _jsx(Grid, { size: { xs: 12, lg: 6 }, paddingInline: isSmallView ? 0 : 1, paddingBlockStart: isSmallView ? 1 : 0, children: _jsxs(Stack, { height: "34vh", maxHeight: 325, gap: 1, children: [_jsx(HistoryLineChart, { historyObject: historyObject, keys: requiredKeys, keyNameMap: (k) => graphableNames[k] ?? k, showTimelineSlider: true, showLegend: false }), KeySelector] }) }), Table] }));
};
export default NetworkAndMessagesTab;
